<template>
    <div class="Man-Lavador-Principal">
        <PageTitle icon="fa fa-bus" main=" Veiculo(s) no Lavador"
            sub="Lançamentos" />
        <div class="Man-Lavador-Principal">
            <b-card no-body>
                <b-tabs>                    
                    <b-tab title="Lavador" active><ManutencaoLavadorLancamento /></b-tab>                                                                                                                        
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import ManutencaoLavadorLancamento from '../man_lavador/ManutencaoLavadorLancamento'
export default {
    name: 'ManutencaoLavadorPrincipal',    
    components: { PageTitle, ManutencaoLavadorLancamento}
    
}
</script>

<style>

</style>






